import { IQueue } from "../../types/User/IQueue";
import { ISetting } from "../../types/User/ISetting";
import { ITeam } from "../../types/User/ITeam";
import { IUserProfile } from "../../types/User/User";
import { baseApi } from "./baseApi";
import { IAccount } from "../../types/User/IAccount";
import { IUserResult } from "../../types/User/IUserResult";

const userApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        searchUsers: build.query<IUserResult[], string>({
            query: (filter) => `/User/Search?filter=${filter}`,
        }),
        getProfile: build.query<IUserProfile, void>({
            query: () => `/User/Profile`,
            providesTags: ["Profile"],
        }),
        getUser: build.query<IUserResult, string>({
            query: (userId) => `/User/${userId}`,
            providesTags: (result, error, id) => [{ type: 'User', id }],
        }),
        getTeams: build.query<ITeam[], void>({
            query: () => "User/Team",
            providesTags: ["Teams"],
        }),
        getQueues: build.query<IQueue[], void>({
            query: () => "User/Group",
            providesTags: ["Queues"],
        }),
        getSetting: build.query<ISetting, number>({
            query: (settingId) => `User/Setting/${settingId}/`,
            providesTags: (result, error, id) => [{ type: 'UserSetting', id }],
        }),
        saveSetting: build.mutation<unknown, ISetting>({
            query: (setting) => ({
                url: `User/Setting/`,
                method: "POST",
                body: setting,
            }),
            invalidatesTags: (result, error, { Setting_Id }) => [{ type: 'UserSetting', id: Setting_Id }],
        }),
        findAccount: build.mutation<IAccount, { tenantUid: string, userId: string }>({
            query: ({ tenantUid, userId }) => ({
                url: `Account/${tenantUid}/BySubjectId`,
                method: "POST",
                body: { SubjectId: userId, Provider: "Microsoft" },
            }),
        }),
    }),
})


export { userApi };